import React from "react";

const DashboardLoader = () => (
  <div className="widgetGrid">
    {Array.from({ length: 12 }).map((_, i) => (
      <div key={i} className="widgetCard">
        <span className="linear-background widgetSkeletonTitle" />
        <div className="widgetCardSkeleton">
          <span className="linear-background widgetSkeletonValue" />
          <span className="linear-background widgetSkeletonTrend" />
        </div>
      </div>
    ))}
  </div>
);

export default DashboardLoader;
